import * as yup from 'yup';

const ALLOWED_THEME_MODES = ['light', 'dark'];

const isValidColor = (value: string): boolean => {
  const s = new Option().style;
  s.color = '';
  s.color = value;
  return s.color !== '';
};

const color = yup
  .string()
  .optional()
  .test(
    'is-color',
    // eslint-disable-next-line no-template-curly-in-string
    '${path} must be a valid CSS color',
    (val) => {
      if (val === undefined) return true;
      return typeof val === 'string' && val.trim() !== '' && isValidColor(val);
    },
  );

const footerSchema = yup.object({
  color,
  background: color,
});

const headerSchema = yup.object({
  color,
  background: color,
  search: yup.object({
    color,
  }),
  indicator: yup.object({
    background: color,
  }),
});

const paletteSchema = yup.object({
  mode: yup.string().oneOf(ALLOWED_THEME_MODES),

  primary: yup.object({
    main: color,
    contrastText: color,
  }),

  secondary: yup.object({
    main: color,
    contrastText: color,
  }),

  background: yup.object({
    paper: color,
    default: color,
  }),
});

const sidebarSchema = yup.object({
  color,
  background: color,

  badge: yup
    .object({
      color,
      background: color,
    })
    .optional(),

  footer: yup
    .object({
      color,
      background: color,
      online: yup
        .object({
          background: color,
        })
        .optional(),
    })
    .optional(),

  header: yup
    .object({
      color,
      background: color,
      brand: yup
        .object({
          color,
        })
        .optional(),
    })
    .optional(),
});

export const singleThemeSchema = yup.object({
  name: yup.string().required(),
  footer: footerSchema.optional(),
  header: headerSchema.optional(),
  palette: paletteSchema.optional(),
  sidebar: sidebarSchema.optional(),
});
